import React from 'react';
import PropTypes from 'prop-types';

import MAGIC_LINK_VARIANTS from '../definitions/MagicLinkVariants';
import MagicLinkForms from './MagicLinkForms';
import MagicLinkFormsLegacy from './MagicLinkFormsLegacy';


function SignInModal({
    isOpen = true,
    onClose,
    supportPhone,
    messages = {},
    magicLinkVariant,
    resumeApplicationLink,
    documentOptions = {},
    shouldShowGoogleSignIn = true,

    // legacy props only used for MtgLandingPage
    isLegacy,
    onRequestLinkCustom,
    emailForForcedLogin,
    hideLoginDescription = false,

    children,

    ...otherProps
}) {
    const commonProps = {
        supportPhone,
        messages,
        magicLinkVariant,
        resumeApplicationLink,
        documentOptions,
        isOpen,
        onClose,
        shouldShowGoogleSignIn,
        ...otherProps,
    };

    return (
        <Choose>
            <When condition={isLegacy}>
                <MagicLinkFormsLegacy
                    hideLoginDescription={hideLoginDescription}
                    onRequestLinkCustom={onRequestLinkCustom}
                    emailForForcedLogin={emailForForcedLogin}
                    {...commonProps}
                />
            </When>
            <Otherwise>
                <MagicLinkForms {...commonProps} >
                    {children}
                </MagicLinkForms>
            </Otherwise>
        </Choose>
    );
}

SignInModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    supportPhone: PropTypes.string,
    messages: PropTypes.object,
    magicLinkVariant: PropTypes.oneOf(Object.values(MAGIC_LINK_VARIANTS)),
    resumeApplicationLink: PropTypes.string,
    documentOptions: PropTypes.object,
    shouldShowGoogleSignIn: PropTypes.bool,
    children: PropTypes.node, // Allows injecting custom content into the modal (non-legacy only)
    /**
     * We need to support legacy sign-in modals for MtgLandingPage and for an experiment.
     * There are prop differences between legacy and non-legacy modals;
     * legacy modals support extra text customization, and forced magic link logins.
     * New usages should use the non-legacy modal which encourages SSO prominence. We will eventually remove legacy modals when the usages are all migrated.
     */
    isLegacy: PropTypes.bool, // Flag to determine if legacy modal should be used
    hideLoginDescription: PropTypes.bool,
    onRequestLinkCustom: PropTypes.func,
    emailForForcedLogin: PropTypes.string,
};

export default SignInModal;
